import React, { lazy, useEffect } from "react";
import { useRoutes, useLocation, Navigate } from "react-router-dom";
import { Login } from "./pages";
import SamplePage from "./pages/samplepage";
import { SharedReports, Blog, BMIScreen, VitalsMetabolicsModal, ConfirmationPopup, ShareReportDialog } from "pageComponents";
const ViewReports = lazy(() => import("../src/components/viewreportslist"));
const ProviderLandingPage = lazy(() => import("../src/pages/providerLandingPage"));
const UserLandingPage = lazy(() => import("../src/pages/userLandingPage"));
const AdminLandingPage = lazy(() => import("../src/pages/adminLandingPage"));
const AccessLandingPage = lazy(() => import("../src/pages/accessLandingPage.jsx"));
const LandingPage = lazy(() => import("../src/pages/landingPage"));
const PageNotFound = lazy(() => import("../src/pages/pageNotFound/pageNotFound"));
const PatientSummarySection = lazy(() => import("../src/components/PatientSummarySection"));

// Tracks the active in-memory route and persists it so that a browser
// refresh can restore the user to the same page instead of falling back
// to the Login screen (MemoryRouter resets to its initialEntries on reload).
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    try {
      sessionStorage.setItem("currentPath", location.pathname);
    } catch (e) {
      // Ignore storage failures (private mode, etc.).
    }
  }, [location.pathname]);
  return null;
};

const AppRouter = () => {

  const routes = useRoutes([
    {
      path: "/",
      element: <Login />,
    },
    // {
    //   path: "/pmr_qa",
    //   element: <Login />,
    // },
    {
      path: "/signup",
      element: <Login />,
    },
    {
      path: "/user-landing-page",
      element: <UserLandingPage />,
    },
    {
      path: "/reports",
      element: <ViewReports />,
    },
    {
      path: "/blog",
      element: <Blog />
    },
    {
      path: "/provider-landing-page",
      element: <ProviderLandingPage />
    },
    {
      path: "/admin-landing-page",
      element: <AdminLandingPage />
    },
    {
      path: "/access-landing-page",
      element: <AccessLandingPage />,
    },
    {
      path: "/landing-page",
      element: <LandingPage />,
    },
    {
      path: "/patient-summary",
      element: <PatientSummarySection />,
    },
    {
      path: "/reset_password",
      element: <Login />,
    },
    {
      path: "/reset_password/:token",
      element: <Login />,
    },
    {
      path: "/secure-login/:token",
      element: <Login />,
    },
    {
      path: "/access-code-validate/:token",
      element: <Login />,
    },
    // {
    //   path: "/blogTwo",
    //   element: <BlogTwo />
    // }
    {
      path: "/404",
      element: <PageNotFound />,
    },
    // If URL is invalid, always go to Login page.
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

  return (
    <>
      <RouteTracker />
      {routes}
    </>
  );
};

export default AppRouter;


